export default "__VITE_ASSET__BIkg9Fkp__"